import { useEffect, useState } from "react"
import { Footer } from "../../../Footer/Footer"
import { Header } from "../../Header/Header"
import { SideBar } from "../../SideBar/SideBar"
import { EmployeeMasterPopUp } from "./Modal/EmployeeMasterPopUp"
import Select from 'react-select'
import DeletePopUp from "../../CommonPopUp/DeletePopUp"
import { DesignationDDL } from "../../../../Components/CommonDDL/DesignationDDL"
import { useDispatch, useSelector } from "react-redux"
import { useAuthState } from "../../../../Helper/Context/context"
import { EmployeeMasterDeleteAPI, EmployeeMasterGetAPI } from "../../../../Helper/Redux/MasterSlice/EmployeeMasterSlice"
import { Loading } from "../../../../Helper/Loader/LogoLoader"
import { Pegination } from "../../../../Components/Pagination/Pagination"
import { useTranslation } from "react-i18next"

export const EmployeeMaster = () => {

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token } = userDetails

    const { t } = useTranslation()

    const [ShowModal, setShowModal] = useState(false)
    const [ModalData, setModalData] = useState({
        Flag: '',
        RowData: ''
    })
    const [ShowDeletePopup, setShowDeletePopup] = useState(false)
    const [ShowDeletePopupData, setShowDeletePopupData] = useState('')
    const [EmployeeName, setEmployeeName] = useState('')
    const [IsSearch, setIsSearch] = useState(false)
    const [IsPost, setIsPost] = useState(false)

    // Pagination
    const [IsClear, setIsClear] = useState(false)
    const [PerPageCount, setPerPageCount] = useState(10)
    const [From, setFrom] = useState(1)
    const [To, setTo] = useState(10)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [isopen, setIsOpen] = useState(false);

    const [Language, setLanguage] = useState({
        DDL: [],
        ID: 0,
        Label: 'English'
    })

    const [DesignationDDLID, setDesignationDDLID] = useState({
        DDL: [],
        ID: 0,
        Label: 'Select...'
    })

    const handleSearch = () => {
        setIsSearch(!IsSearch)
    }

    const handleClear = () => {
        setIsClear(!IsClear)
        setDesignationDDLID({
            ...DesignationDDLID,
            ID: 0,
            Label: 'Select...'
        })
    }

    const handleIsPost = () => {
        setIsPost(!IsPost)
    }

    const handleShowModal = (apiFlag, rowData) => {
        setShowModal(!ShowModal)
        setModalData({
            Flag: apiFlag ? apiFlag : '',
            RowData: rowData ? rowData : ''
        })
    }

    const handleShowDelete = (rowData) => {
        setShowDeletePopup(!ShowDeletePopup)
        setModalData({
            Flag: '',
            RowData: rowData ? rowData : ''
        })
    }

    const handleDelete = () => {
        const data = {
            M_EmployeeID: ModalData.RowData.m_EmployeeID,
            M_UserID: UserID,
            token: token,
            handleShowDelete: handleShowDelete,
            handleIsPost: handleIsPost
        }
        dispatch(EmployeeMasterDeleteAPI({ data }))
    }

    useEffect(() => {
        const data = {
            M_DesignationID: DesignationDDLID.ID,
            EmployeeName,
            FromTop: From,
            ToTop: To,
            M_UserID: UserID,
            token: token
        }
        dispatch(EmployeeMasterGetAPI({ data }))
    }, [IsSearch, IsClear, IsPost, To])

    const { TableData, isLoading } = useSelector(state => state.EmployeeMasterGetData)

    return (
        <>
            {isLoading && <Loading />}
            <Header
                Language={Language}
                setLanguage={setLanguage}
            />
            <div id="wrapper" className="d-flex justify-content-center">
                {/* <!-- Content Wrapper --> */}
                <SideBar active="EmployeeMaster" />
                <div className="main-content user_dashboard d-flex flex-column body-scroll px-1 px-lg-3 justify-content-between" id='content' >
                    <div className="content-wrapper " >
                        <div className="row my-2">
                            <div className="page-heading col-12 mb-xl-0  px-lg-4  d-flex justify-content-between align-items-center">
                                <h6 className="fs-7 font-weight-bold text-black ">{t('DirectorDashboard.EmployeeMaster')}</h6>
                                <a type="button"
                                    onClick={() => handleShowModal('Insert')}
                                    className="btn btn-dark border-2  "><i
                                        className="fa-solid fa-plus me-1"></i> Add
                                </a>
                            </div>
                        </div>
                        <div className="row my-2">
                            <div className="col-12 ">
                                <div className="card mb-4 overflow-hidden">
                                    <div className="card-body px-3 py-2 linear-g">
                                        <div className="row mb-4">
                                            <div className=" col-lg-3">
                                                <label for="Status" style={{ fontWeight: '500', color: '#696969' }}>{t('DirectorDashboard.Designation')}</label>
                                                <DesignationDDL
                                                    DesignationDDLID={DesignationDDLID}
                                                    setDesignationDDLID={setDesignationDDLID}
                                                />
                                            </div>
                                            <div className=" col-lg-3 pt-3 pt-lg-0">
                                                <label for="Employee" style={{ fontWeight: '500', color: '#696969' }}>{t('GridHeading.Employee')}</label>
                                                <input
                                                    type="text"
                                                    className="form-control inputstyle"
                                                    placeholder=""
                                                    aria-label="EmployeeName"
                                                    aria-describedby="addon-wrapping"
                                                    value={EmployeeName}
                                                    onChange={(e) => setEmployeeName(e.target.value)}
                                                />
                                            </div>

                                            <div className="col-12 col-md-6 col-lg-4 pt-2 mt-3 mt-lg-2 pt-lg-4 pb-3 pb-lg-0 align-items-end ">
                                                <button type="button" className="btn btn-outline-dark border-2 mx-2 button-size"
                                                    onClick={handleSearch}
                                                >
                                                    Search</button>

                                                <button type="button" className="btn btn-danger border-2 button-size"
                                                    onClick={handleClear}
                                                >Clear</button>
                                            </div>
                                        </div>

                                        {/* <TableData /> */}

                                        <div className="table-responsive p-0">
                                            <table className="table table-bordered w-100">
                                                <thead>
                                                    <tr className="bg-dark">
                                                        <th className="">{t('GridHeading.Sr_No')}</th>
                                                        <th className=" ps-2">{t('DirectorDashboard.Designation')}</th>
                                                        <th className=" ps-2">{t('GridHeading.Employee')}</th>
                                                        <th className=" ps-2  w-10">{t('GridHeading.Action')}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        TableData && TableData.length > 0 ?
                                                            TableData.map((i, index) => {
                                                                return (
                                                                    <tr>
                                                                        <td className="w-10">{i?.rowNum}</td>
                                                                        <td>{i?.designationName}</td>
                                                                        <td>{i?.employeeName}</td>
                                                                        <td className="text-center w-20">
                                                                            <span className="cursor-pointer"
                                                                                onClick={() => handleShowModal('Update', i)}
                                                                            >
                                                                                <i class="fa-solid fa-pen-to-square"></i>
                                                                            </span>
                                                                            <span className="cursor-pointer"
                                                                                onClick={() => handleShowDelete(i)}
                                                                            >
                                                                                <i class="fa-solid fa-trash mx-4"></i>
                                                                            </span>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })
                                                            : <>No data found</>
                                                    }

                                                </tbody>
                                            </table>
                                        </div>
                                        {TableData && TableData.length > 0 &&
                                            <Pegination
                                                PerPageCount={PerPageCount}
                                                TotalCount={TableData[0].totalCount}
                                                setFrom={setFrom}
                                                setTo={setTo}
                                                CurrentPage={CurrentPage}
                                                setCurrentPage={setCurrentPage}
                                                IsClear={IsClear}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
                {
                    ShowModal &&
                    <EmployeeMasterPopUp
                        handleShowModal={handleShowModal}
                        handleIsPost={handleIsPost}
                        ModalData={ModalData}
                    />
                }
                {
                    ShowDeletePopup &&
                    <DeletePopUp
                        handleShowDelete={handleShowDelete}
                        handleDelete={handleDelete}
                    />
                }
            </div>
        </>
    )
}